import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Box } from '@uhg-abyss/web/ui/Box';
import { WorkLoadMonitor } from './Wlm/WorkLoadMonitor';

export const WlmHome = () => {
  return (
    <>
      <Router.MetaTags title="WLM" />
      <Box color="transparent" padding="16px">
        <WorkLoadMonitor />
      </Box>
    </>
  );
};